<div class="download-modal-container" *ngIf='opened'>
    <div class="card">
        <div class="card-header d-flex align-items-center justify-content-center">
            <h4 style="margin-top: 20px;">Descarga de estudio DICOM</h4>
        </div>

        <hr class="hr">

        <div class="card-body p-3" style="overflow-y: overlay;">
            <div class="options">

                <div class="option" >
                    <div class="row">
                        <p>Se procederá a la descarga de las imágenes completas del estudio en formato de diagnóstico
                        </p>
                        <p>Esta descarga puede tardar unos
                            minutos. Por favor, asegúrese de tener suficiente espacio de almacenamiento en el
                            dispositivo.</p>
                        <p>Si está conectado a internet usando datos móviles, es posible que consuma parte de su
                            tarifa de datos. Se recomienda realizar la descarga conectado a una red WiFi</p>
                        <p>¿Está seguro de que desea continuar?</p>
                    </div>
                    <div class="btn_row">
                        <button class="cancel_btn" (click)="closeModal()">Cancelar</button>
                        <button class="download_btn" (click)="downloadDicom()">Descargar</button>
                    </div>


                </div>


            </div>
        </div>

    </div>
</div>